import { render, staticRenderFns } from "./agendamento.vue?vue&type=template&id=29edbf6a&scoped=true"
import script from "./agendamento.vue?vue&type=script&lang=js"
export * from "./agendamento.vue?vue&type=script&lang=js"
import style0 from "./agendamento.vue?vue&type=style&index=0&id=29edbf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29edbf6a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PaymentFormRegisterBuyer: require('/home/luiz/Sistemas/loja/components/Payment/Form/RegisterBuyer.vue').default,ScheduleUploadDocs: require('/home/luiz/Sistemas/loja/components/Schedule/UploadDocs.vue').default,ScheduleScheduling: require('/home/luiz/Sistemas/loja/components/Schedule/Scheduling.vue').default})
